// User service for managing user profiles

import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { User } from '../types/shared';

export type UserProfile = Partial<User>;

export async function getUserProfile(uid: string): Promise<UserProfile> {
    const docRef = doc(db, 'users', uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        return docSnap.data() as UserProfile;
    } else {
        // Return empty profile for new users
        return {};
    }
}

export async function updateUserProfile(uid: string, updates: Partial<UserProfile>): Promise<void> {
    const docRef = doc(db, 'users', uid);
    await setDoc(docRef, updates, { merge: true });
}
